import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_terms_of_service_checkbox_field = _resolveComponent("terms-of-service-checkbox-field")
  const _component_right_of_withdrawal_consent_checkbox_field = _resolveComponent("right-of-withdrawal-consent-checkbox-field")
  const _component_base_button = _resolveComponent("base-button")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    "is-visible": $props.isVisible,
    title: _ctx.Resources.Common.ModalConfirmToContinueTitle,
    "is-processing": $props.isProcessing
  }, {
    actions: _withCtx(() => [
      _createElementVNode("button", {
        class: "gfu-link gfu-link--accent",
        onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.onClose && $options.onClose(...args)), ["prevent"])),
        "data-qa": "modal-button:Cancel"
      }, _toDisplayString(_ctx.Resources.Common.ModalCancelButton), 1 /* TEXT */),
      _createVNode(_component_base_button, {
        theme: "accent",
        enabled: $options.canConfirm,
        onClick: _withModifiers($options.onConfirm, ["prevent"]),
        "data-qa": "modal-button:Confirm"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.Resources.Common.ModalConfirmButton), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["enabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_terms_of_service_checkbox_field, {
        modelValue: $data.model.termsAccepted,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.termsAccepted) = $event)),
        name: "model.termsAccepted",
        "show-digital-content-info": ""
      }, null, 8 /* PROPS */, ["modelValue"]),
      _createVNode(_component_right_of_withdrawal_consent_checkbox_field, {
        modelValue: $data.model.isRightOfWithdrawalConsentAccepted,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.model.isRightOfWithdrawalConsentAccepted) = $event)),
        name: "model.isRightOfWithdrawalConsentAccepted"
      }, null, 8 /* PROPS */, ["modelValue"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-visible", "title", "is-processing"]))
}